import moment from "moment";
import React from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { COLOR_APP, COLOR_APP_CANCEL } from "../../constants";
import { MdDelete } from "react-icons/md";

import { BiSolidEdit } from "react-icons/bi";
import { FaEdit } from "react-icons/fa";
import PaginationsV1 from "../../components/PaginationV1";
import LoadingSpinner from "../../components/LoadingSpinner";

function ListInfulancer({
  commisionInfluencer,
  loadingCommision,
  setGetDataCommission,
  setInfulancer,
  handleOpenModalConfirm,
  commissionTotal,
  page,
  pageAll,
  handleChangePage,
  rowsPerPage,
}) {
  if (loadingCommision) {
    return (
      <div className="w-100 h-50 d-flex justify-content-center align-items-center">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <>
      <div>
        <Table>
          <thead>
            <tr>
              <th>ລດ</th>
              <th>ຊື່ ອາຟຣິລີເອດ</th>
              <th>ຄອມມິດຊັ່ນ</th>
              <th>ໝາຍເຫດ</th>
              <th>ວັນທີສ້າງ</th>
              <th>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {commisionInfluencer ? (
              commisionInfluencer.map((data, index) => (
                <tr key={index}>
                  <td>{page * rowsPerPage + index + 1}</td>
                  <td>{data?.shop_name ?? "-"}</td>
                  <td>{data?.commission ?? "-"}</td>
                  <td>{data?.note ?? "-"}</td>
                  <td>{moment(data?.startDate).format("DD/MM/YYYY  HH:mm")}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <Button
                        style={{ background: COLOR_APP }}
                        onClick={() =>
                          setInfulancer({
                            show: true,
                            data: data,
                            index: index,
                            editMode: true,
                          })
                        }>
                        <FaEdit />
                        &nbsp; ແກ້ໄຂ
                      </Button>
                      <Button
                        onClick={() => handleOpenModalConfirm(data)}
                        style={{
                          background: COLOR_APP_CANCEL,
                          border: "1px solid red",
                        }}>
                        <MdDelete />
                        &nbsp; ລົບ
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <PaginationsV1
        count={commissionTotal}
        rowsPerPage={rowsPerPage}
        page={page}
        pageAll={pageAll}
        onPageChange={handleChangePage}
      />
    </>
  );
}

export default ListInfulancer;
